import SeoPage from "../components/SeoPage";

export default function SoftwareCompany() {
  return (
    <SeoPage
      title="Software Development Company in India | Arviko"
      description="Best software company in India offering web, mobile and AI solutions."
      heading="Software Development Company in India"
    >
      <p>
        Arviko Technology delivers high-quality software solutions for businesses.
      </p>
    </SeoPage>
  );
}